import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IntroSection } from '../components/IntroSection';
import { CurrentIssue } from '../components/CurrentIssue';
import { PublishingCycle } from '../components/PublishingCycle';
import { ArchivePreview } from '../components/ArchivePreview';
import { AboutSection } from '../components/AboutSection';
import { SubscriptionSupport } from '../components/SubscriptionSupport';
import { Language } from '../App';
interface HomeProps {
  language: Language;
}
export function Home({
  language
}: HomeProps) {
  return <div data-id="element-553">
      <HeroSection language={language} data-id="element-554" />
      <IntroSection language={language} data-id="element-555" />
      <CurrentIssue language={language} data-id="element-556" />
      <PublishingCycle language={language} data-id="element-557" />
      <ArchivePreview language={language} data-id="element-558" />
      <AboutSection language={language} data-id="element-559" />
      <SubscriptionSupport language={language} data-id="element-560" />
    </div>;
}